import * as d3 from 'd3';
import data from '../../../../data/data.json';

let texasShootings = data['shootings'],
  nonTexasShootings = data['non-texas-shootings'];

texasShootings.forEach(s => {
  let killedContainer = d3
    .select(`[class="killed-injured-count"][name="${s.name}"]`)
    .append('div')
    .html(
      `<div class="killed-count-header"><span class="number-killed">${s.killed}</span> Killed</div>`
    )
    .attr('class', 'killed-count')
    .append('div')
    .attr('class', 'killed-count-people');

  let injuredContainer = d3
    .select(`[class="killed-injured-count"][name="${s.name}"]`)
    .append('div')
    .html(
      `<div class="injured-count-header"><span class="number-injured">${
        s.injured
      }</span> ${
        s.injured == 'An unknown number' ? 'injured' : 'Injured'
      }</div>`
    )
    .attr('class', 'injured-count')
    .append('div')
    .attr('class', 'injured-count-people');

  killedContainer
    .selectAll('div')
    .data(d3.range(s.killed))
    .enter()
    .append('span')
    .html(
      '<span><svg class="icon icon-person-killed"><use xlink:href="#icon-person-killed"></use></svg></span>'
    );

  injuredContainer
    .selectAll('div')
    .data(d3.range(s.injured))
    .enter()
    .append('span')
    .html(
      '<span><svg class="icon icon-person-injured"><use xlink:href="#icon-person-injured"></use></svg></span>'
    );
});
